export class NavItem {
  constructor(
    public title: string,
    public route: string,
    public icon?: string,
    public subject?: string,
  ) {}
}
